import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    category: {
      position: "relative",
      "&::before": {
        content: "''",
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        opacity: 0,
        backgroundColor: theme.palette.primary.main,
        willChange: "opacity",
        transform: "opacity 0.1s cubic-bezier(0.25, 1, 0.5, 1)",
      },
      "&:hover::before": {
        opacity: 0.7,
      },
    },
    image: {
      maxWidth: "100%",
      display: "block",
    },
  }),
  { name: "Pill" },
);
